import React, { useState, useEffect, useMemo } from 'react';

import {
  useGetCustomerPersonasQuery,
  useCreateCustomerPersonaMutation,
  useDeleteCustomerPersonaMutation,
  useAssignPersonaContractorsMutation,
} from './customerPersonaApiSlice';
import { useGetContractorsQuery } from '../contractors/contractorsApiSlice';
import { Pill, Select as UiSelect, Badge } from '../../components/adminUi';
import {
  Header,
  Button,
  Icon,
  Card,
  Modal,
  Container,
  Loader,
  Pagination,
  Input,
  Table,
  Segment,
  Popup,
  Label,
  Form,
  Grid,
  Checkbox,
} from 'semantic-ui-react';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from '../auth/authSlice';

import { PAGE_SIZE, formatDate } from '../../constants';
import CustomerPersonaDetail from './CustomerPersonaDetail';
import '../../components/SharedCard.css';

const DeleteCustomerPersonaButton = props => {
  const [isActive, setIsActive] = useState(false);

  const [deleteCustomerPersona] = useDeleteCustomerPersonaMutation();

  let content;

  const toggleIsActive = () => {
    setIsActive(!isActive);
  };

  const handleDelete = () => {
    deleteCustomerPersona(props.customer_persona.id);
  };

  if (isActive) {
    content = (
      <Button.Group fluid size="mini">
        <Button
          inverted
          onClick={toggleIsActive}
          size="mini"
          icon="delete"
          color="red"
        />
        <Button
          onClick={handleDelete}
          inverted
          size="mini"
          icon="check"
          color="green"
        />
      </Button.Group>
    );
  } else {
    content = (
      <Button
        fluid
        onClick={toggleIsActive}
        inverted
        size="mini"
        icon="x"
        color="red"
      />
    );
  }

  return content;
};

const AddCustomerPersonaForm = () => {
  const [addCustomerPersona] = useCreateCustomerPersonaMutation();
  const [open, setOpen] = useState(false);
  const [purpose_of_visit, setPurposeOfVisit] = useState('');

  const handlePurposeOfVisitChange = (e, v) => {
    setPurposeOfVisit(v.value);
  };

  const handleClickNewCustomerPersona = async () => {
    try {
      await addCustomerPersona(purpose_of_visit).unwrap();
      setPurposeOfVisit('');
      setOpen(false);
    } catch (err) {
      console.log('failed to create new persona');
    }
  };

  return (
    <Modal
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
      trigger={
            <Button
              primary
              icon
              labelPosition="right"
              // onClick={() => setModalOpen(true)}
              style={{
                borderRadius: '30px',
                height: '40px',
                backgroundColor: '#0091FF',
                paddingLeft: '20px',
                paddingRight: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
          새 페르소나
          <Icon name="plus" style={{ marginLeft: '8px', margin: 0 }} />
        </Button>
      }
      size="tiny"
      style={{
        borderRadius: '20px',
        overflow: 'hidden',
        boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
        border: 'none',
      }}
    >
      <Modal.Header
        style={{
          background: 'linear-gradient(135deg, #007AFF 0%, #00C6FF 100%)',
          color: 'white',
          border: 'none',
          padding: '24px 28px',
          fontSize: '1.2em',
          fontWeight: '600',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div
            style={{
              background: 'rgba(255,255,255,0.2)',
              borderRadius: '12px',
              width: '40px',
              flexShrink: 0, // stays a circle when the text beside it wraps
              height: '40px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Icon name="user plus" style={{ margin: 0, color: 'white' }} />
          </div>
          새 고객 페르소나 추가
        </div>
      </Modal.Header>
      <Modal.Content style={{ padding: '28px' }}>
        <p style={{ color: '#86868b', fontSize: '0.95em', marginBottom: '16px' }}>
          새로운 페르소나의 방문 목적이나 특징을 자유롭게 입력해주세요.
        </p>
        <Form>
          <Form.TextArea
            placeholder="예: iPhone 16 Pro Max 구매를 고민 중인 30대 직장인..."
            onChange={handlePurposeOfVisitChange}
            value={purpose_of_visit}
            autoFocus
            rows={5}
            style={{
              borderRadius: '12px',
              border: '1px solid rgba(0,0,0,0.1)',
              padding: '14px',
              fontSize: '0.95em',
              resize: 'none',
              transition: 'border-color 0.2s ease',
            }}
          />
        </Form>
      </Modal.Content>
      <Modal.Actions
        style={{
          background: '#f8f9fa',
          borderTop: '1px solid rgba(0,0,0,0.05)',
          padding: '16px 28px',
        }}
      >
        <Button
          onClick={() => setOpen(false)}
          style={{
            borderRadius: '20px',
            background: 'white',
            color: '#1d1d1f',
            border: '1px solid rgba(0,0,0,0.1)',
            fontWeight: '500',
            padding: '10px 24px',
            transition: 'all 0.2s ease',
          }}
        >
          취소
        </Button>
        <Button
          onClick={handleClickNewCustomerPersona}
          disabled={!purpose_of_visit}
          style={{
            borderRadius: '20px',
            background: purpose_of_visit
              ? 'linear-gradient(45deg, #007AFF, #0055FF)'
              : '#e0e0e0',
            color: purpose_of_visit ? 'white' : '#999',
            fontWeight: '600',
            padding: '10px 28px',
            boxShadow: purpose_of_visit
              ? '0 6px 16px rgba(0,122,255,0.3)'
              : 'none',
            border: 'none',
            transition: 'all 0.3s ease',
          }}
        >
          <Icon name="checkmark" style={{ marginRight: '6px' }} />
          생성
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

const CustomerPersonasList = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(location.search);
  const page = queryParams.get('page');
  const page_size = queryParams.get('page_size');
  const currentUser = useSelector(selectCurrentUser);
  const isStaff = currentUser?.is_staff === true;
  const isSuperuser = currentUser?.is_superuser === true;

  // The 사용자 필터 is gone with dynamic personas, so scope no longer varies by
  // selection. Non-staff keep `user_only` — the route admits 파트너 관리자, and
  // `scope=all` would 403 them rather than showing an empty list.
  const scope = isStaff ? 'all' : 'user_only';
  const listParams = { page, page_size, scope };

  const { data, isLoading, isSuccess, isError, error } =
    useGetCustomerPersonasQuery(
      listParams,
      {
        pollingInterval: 5000,
      },
    );

  const [selectedCustomerPersona, setSelectedCustomerPersona] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Bulk contractor assignment (superuser only)
  const [selectedIds, setSelectedIds] = useState([]);
  const [assignContractorId, setAssignContractorId] = useState('');
  const { data: contractorsData } = useGetContractorsQuery(
    { page_size: 1000 },
    { skip: !isSuperuser },
  );
  const [assignPersonaContractors, { isLoading: isAssigning }] =
    useAssignPersonaContractorsMutation();

  const contractorOptions = useMemo(
    () =>
      (contractorsData?.results || []).map(c => ({
        key: c.id,
        value: c.id,
        text: c.name,
      })),
    [contractorsData],
  );

  const toggleSelected = id =>
    setSelectedIds(prev =>
      prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id],
    );

  const handleAssign = async op => {
    if (!assignContractorId || selectedIds.length === 0) return;
    try {
      await assignPersonaContractors({
        persona_ids: selectedIds,
        contractor_id: assignContractorId,
        op,
      }).unwrap();
      setSelectedIds([]);
    } catch (err) {
      console.log('failed to assign contractors');
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handlePaginationChange = (e, { activePage }) => {
    setSelectedCustomerPersona(null);
    const searchParams = new URLSearchParams(location.search);
    searchParams.set('page', activePage);
    searchParams.set('page_size', PAGE_SIZE);
    navigate(`${location.pathname}?${searchParams.toString()}`);
  };

  if (isLoading) return <Loader active />;
  if (isError) return null;

  return (
    <div
      style={{
        // backgroundColor: '#f9fafb',
        // minHeight: '100vh',
        height: isMobile ? 'auto' : 'auto',
        display: isMobile ? 'block' : 'flex',
        flexDirection: 'column',
        overflow: isMobile ? 'visible' : 'hidden',
      }}
    >
      {/* Header Section */}
      <div
        style={{
          flex: '0 0 auto',
          padding: '16px 0',
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          backdropFilter: 'blur(20px)',
          borderBottom: '1px solid rgba(0,0,0,0.05)',
          marginBottom: isMobile ? '20px' : '0',
          position: 'relative',
          zIndex: 100,
        }}
      >
        <Container fluid={!isMobile}>
          {/* Same fix as the 관리자 대시보드 header: one unwrappable row put the title,
              a 180px dropdown and the 새 페르소나 button side by side, so at 390px the
              title wrapped to one character per line. */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '0 20px',
              flexWrap: 'wrap',
              gap: '12px',
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', minWidth: 0 }}>
              <div
                style={{
                  width: '40px',
                  flexShrink: 0, // stays a circle when the text beside it wraps
                  height: '40px',
                  borderRadius: '50%',
                  backgroundColor: '#F2F2F7',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Icon
                  name="id card outline"
                  style={{ margin: 0, color: '#007AFF', fontSize: '18px' }}
                />
              </div>
              <div>
                <h2
                  style={{
                    fontSize: '17px',
                    fontWeight: '600',
                    margin: 0,
                    color: '#1d1d1f',
                  }}
                >
                  고객 페르소나 목록
                </h2>
                <p style={{ fontSize: '13px', color: '#86868b', margin: 0 }}>
                  관리 및 상세 정보 확인
                </p>
              </div>
            </div>
            <div
              style={{
                display: 'flex',
                gap: '1rem',
                alignItems: 'center',
                flexWrap: 'wrap',
                justifyContent: 'flex-end',
                width: isMobile ? '100%' : 'auto',
              }}
            >
              <div style={{ width: 'auto' }}>
                <AddCustomerPersonaForm />
              </div>
            </div>
          </div>
        </Container>
      </div>

      <Container
        fluid={!isMobile}
        style={{
          padding: isMobile ? '0 20px' : '20px',
          flex: isMobile ? 'none' : 1,
          display: isMobile ? 'block' : 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {isMobile ? (
          <>
            {/* Card Grid */}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: '1fr',
                gap: '16px',
              }}
            >
              {data.results.map(persona => (
                <div
                  key={persona.id}
                  onClick={() => setSelectedCustomerPersona(persona)}
                  className="custom-card"
                  style={{
                    opacity: persona.deactivated_at ? 0.6 : 1,
                    backgroundColor: persona.deactivated_at ? '#f5f5f5' : undefined,
                  }}
                >
                  <div className="custom-card-status-container">
                    <Popup
                      trigger={
                        <div
                          className="custom-card-status-dot"
                          style={{
                            backgroundColor: persona.is_postprocessed
                              ? '#34C759'
                              : '#FF9500',
                          }}
                        />
                      }
                      content={
                        persona.is_postprocessed
                          ? '페르소나 상세 정보 생성 완료'
                          : '페르소나 상세 정보 생성 중...'
                      }
                      position="top center"
                    />
                  </div>

                  {/* Same identifier as the table and as the trainee's own screen:
                      N번 고객, not the generated name and gender. */}
                  <div className="custom-card-header">
                    <h3 className="custom-card-title">
                      {persona.int_id ? `${persona.int_id}번 고객` : '번호 없음'}
                    </h3>
                  </div>

                  <p className="custom-card-description">
                    {persona.purpose_of_visit}
                  </p>

                  <div className="custom-card-actions">
                    <Button
                      fluid
                      size="small"
                      className="custom-card-btn-secondary"
                      onClick={e => {
                        e.stopPropagation();
                        setSelectedCustomerPersona(persona);
                      }}
                    >
                      상세보기
                    </Button>
                    <Button
                      fluid
                      size="small"
                      className="custom-card-btn-primary"
                      onClick={e => {
                        e.stopPropagation();
                        navigate(
                          `/chatsessionslist?page=1&page_size=${PAGE_SIZE}&persona=${persona.id}`,
                        );
                      }}
                    >
                      세션 ({persona.count_chatsession})
                    </Button>
                  </div>
                </div>
              ))}
            </div>

            {/* Detail Modal for Grid View */}
            <Modal
              open={!!selectedCustomerPersona}
              onClose={() => setSelectedCustomerPersona(null)}
              closeIcon
              size="small"
            >
              <Modal.Header>페르소나 상세 정보</Modal.Header>
              <Modal.Content scrolling>
                <CustomerPersonaDetail
                  customer_persona={selectedCustomerPersona}
                />
              </Modal.Content>
            </Modal>
          </>
        ) : (
          /* Table Split View */
          <Grid style={{ margin: 0 }} container={false}>
            {/* Left Pane: Table & Pagination */}
            {/* 10/6, not 8/8: the list is a working surface with six columns and the detail
                pane is a read-only summary, so an even split starved the table and left
                the 설명 column truncating at 40 characters. */}
            <Grid.Column width={10} style={{ paddingBottom: 0 }}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  backgroundColor: 'white',
                  borderRadius: '12px',
                  border: '1px solid rgba(0,0,0,0.05)',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                  overflowY: 'auto',
                  // maxHeight: '100%',
                }}
              >
                {isSuperuser && selectedIds.length > 0 && (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      padding: '10px 12px',
                      borderBottom: '1px solid rgba(0,0,0,0.05)',
                      backgroundColor: '#f8f9fa',
                      flexWrap: 'wrap',
                    }}
                  >
                    <span style={{ fontSize: '13px', fontWeight: 600, color: '#1d1d1f' }}>
                      {selectedIds.length}개 선택됨
                    </span>
                    <UiSelect
                      value={assignContractorId}
                      onChange={e => setAssignContractorId(e.target.value)}
                      style={{ width: 'auto', minWidth: '160px' }}
                    >
                      <option value="">파트너 선택…</option>
                      {contractorOptions.map(o => (
                        <option key={o.value} value={o.value}>{o.text}</option>
                      ))}
                    </UiSelect>
                    <Pill
                      variant="primary"
                      disabled={!assignContractorId || isAssigning}
                      onClick={() => handleAssign('assign')}
                    >
                      배정
                    </Pill>
                    <Pill
                      variant="danger"
                      disabled={!assignContractorId || isAssigning}
                      onClick={() => handleAssign('unassign')}
                    >
                      배정 해제
                    </Pill>
                    <Pill variant="ghost" onClick={() => setSelectedIds([])}>
                      선택 해제
                    </Pill>
                  </div>
                )}
                <div>
                  <Table
                    compact="very"
                    selectable
                    singleLine
                    style={{ margin: 0, border: 'none' }}
                  >
                    <Table.Header
                      style={{
                        position: 'sticky',
                        top: 0,
                        zIndex: 1,
                        backgroundColor: 'white',
                      }}
                    >
                      <Table.Row>
                        {isSuperuser && (
                          <Table.HeaderCell
                            collapsing
                            style={{
                              borderBottom: '1px solid rgba(34,36,38,.15)',
                            }}
                          />
                        )}
                        {/* 번호 replaces both the truncated pk and the 이름/성별 column.
                            N번 고객 is the only persona identifier the trainee and the
                            client ever use; the pk was a 5-character fragment that
                            identified nothing on its own, and the generated name and
                            gender are not how anyone refers to these. */}
                        <Table.HeaderCell
                          collapsing
                          textAlign="center"
                          style={{
                            borderBottom: '1px solid rgba(34,36,38,.15)',
                          }}
                        >
                          번호
                        </Table.HeaderCell>
                        <Table.HeaderCell
                          width={7}
                          style={{
                            borderBottom: '1px solid rgba(34,36,38,.15)',
                          }}
                        >
                          설명
                        </Table.HeaderCell>
                        <Table.HeaderCell
                          width={2}
                          style={{
                            borderBottom: '1px solid rgba(34,36,38,.15)',
                          }}
                        >
                          세션 수
                        </Table.HeaderCell>
                        <Table.HeaderCell
                          width={2}
                          style={{
                            borderBottom: '1px solid rgba(34,36,38,.15)',
                          }}
                        >
                          파트너 수
                        </Table.HeaderCell>
                        <Table.HeaderCell
                          width={2}
                          style={{
                            borderBottom: '1px solid rgba(34,36,38,.15)',
                          }}
                        >
                          액션
                        </Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>
                      {data.results.map(persona => (
                        <Table.Row
                          key={persona.id}
                          active={selectedCustomerPersona?.id === persona.id}
                          onClick={() => setSelectedCustomerPersona(persona)}
                          style={{
                            cursor: 'pointer',
                            backgroundColor: persona.deactivated_at ? '#f5f5f5' : undefined,
                            color: persona.deactivated_at ? '#999' : undefined,
                          }}
                        >
                          {isSuperuser && (
                            <Table.Cell
                              collapsing
                              onClick={e => e.stopPropagation()}
                            >
                              <Checkbox
                                checked={selectedIds.includes(persona.id)}
                                disabled={persona.is_dynamic}
                                onChange={() => toggleSelected(persona.id)}
                              />
                            </Table.Cell>
                          )}
                          <Table.Cell
                            textAlign="center"
                            onClick={e => {
                              e.stopPropagation();
                              navigator.clipboard.writeText(persona.id);
                            }}
                            style={{ cursor: 'pointer' }}
                            title="클릭하면 페르소나 ID가 복사됩니다"
                          >
                            {/* The pk is still one click away for support work — it just
                                no longer occupies a column of its own. */}
                            <Label
                              circular
                              color={
                                selectedCustomerPersona?.id === persona.id
                                  ? 'blue'
                                  : undefined
                              }
                            >
                              {persona.int_id ?? '-'}
                            </Label>
                          </Table.Cell>
                          {/* Ellipsis in CSS rather than slicing at 40 characters in JS:
                              a fixed cut was tuned to the old half-width column and
                              truncated mid-word well before the new one runs out of
                              room. The full text stays in the title attribute. */}
                          <Table.Cell
                            title={persona.purpose_of_visit}
                            style={{
                              maxWidth: 0,
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {persona.purpose_of_visit}
                          </Table.Cell>
                          <Table.Cell textAlign="center">
                            <Label basic>{persona.count_chatsession}</Label>
                          </Table.Cell>
                          <Table.Cell textAlign="center">
                            {persona.count_contractors > 0 ? (
                              <Badge tone="blue">{persona.count_contractors}</Badge>
                            ) : (
                              <span style={{ color: '#999' }}>-</span>
                            )}
                          </Table.Cell>
                          <Table.Cell textAlign="center">
                            <Button
                              size="mini"
                              icon="comments"
                              content="대화 내역"
                              style={{borderRadius: '14px'}}
                              onClick={e => {
                                e.stopPropagation();
                                navigate(
                                  `/chatsessionslist?page=1&page_size=${PAGE_SIZE}&persona=${persona.id}`,
                                );
                              }}
                            />
                          </Table.Cell>
                        </Table.Row>
                      ))}
                    </Table.Body>
                  </Table>
                </div>

                {/* Pagination inside Left Pane */}
                <div
                  style={{
                    padding: '12px',
                    borderTop: '1px solid rgba(0,0,0,0.05)',
                    display: 'flex',
                    justifyContent: 'center',
                    backgroundColor: '#f8f9fa',
                  }}
                >
                  <Pagination
                    activePage={page}
                    onPageChange={handlePaginationChange}
                    totalPages={Math.ceil(data.count / page_size)}
                    size="mini"
                    ellipsisItem={{
                      content: <Icon name="ellipsis horizontal" />,
                      icon: true,
                    }}
                    firstItem={{
                      content: <Icon name="angle double left" />,
                      icon: true,
                    }}
                    lastItem={{
                      content: <Icon name="angle double right" />,
                      icon: true,
                    }}
                    prevItem={{
                      content: <Icon name="angle left" />,
                      icon: true,
                    }}
                    nextItem={{
                      content: <Icon name="angle right" />,
                      icon: true,
                    }}
                  />
                </div>
              </div>
            </Grid.Column>

            {/* Right Pane: Detail */}
            <Grid.Column width={6} style={{ paddingBottom: 0 }}>
              <div
                style={{
                  backgroundColor: 'white',
                  borderRadius: '12px',
                  border: '1px solid rgba(0,0,0,0.05)',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                  position: 'relative',
                  overflow: 'hidden',
                  height: 'calc(100vh - 200px)',
                }}
              >
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    overflowY: 'auto',
                  }}
                >
                  {selectedCustomerPersona ? (
                    <div style={{ padding: '20px' }}>
                      <CustomerPersonaDetail
                        customer_persona={selectedCustomerPersona}
                      />
                    </div>
                  ) : (
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100%',
                        color: '#86868b',
                      }}
                    >
                      <Icon
                        name="hand point left outline"
                        size="huge"
                        style={{ marginBottom: '1rem' }}
                      />
                      <p>
                        좌측 목록에서 페르소나를 선택하여 상세 내용을
                        확인하세요.
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </Grid.Column>
          </Grid>
        )}

        {/* Mobile Pagination */}
        {isMobile && (
          <div
            style={{
              marginTop: '2rem',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Pagination
              activePage={page}
              onPageChange={handlePaginationChange}
              totalPages={Math.ceil(data.count / page_size)}
              ellipsisItem={{
                content: <Icon name="ellipsis horizontal" />,
                icon: true,
              }}
              firstItem={{
                content: <Icon name="angle double left" />,
                icon: true,
              }}
              lastItem={{
                content: <Icon name="angle double right" />,
                icon: true,
              }}
              prevItem={{ content: <Icon name="angle left" />, icon: true }}
              nextItem={{ content: <Icon name="angle right" />, icon: true }}
            />
          </div>
        )}
      </Container>
    </div>
  );
};

export default CustomerPersonasList;

export { CustomerPersonaDetail };
